/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGeoExV4 } from '../geo/GeoExV4';
import type { IPriceRangeEx } from '../price_range/PriceRangeEx';
import type { IDecimalRangeEx } from '../range/DecimalRangeEx';

export interface ICreatePersonalMessageV2Request {
  /** Принято ли соглашение на маркетинговые коммуникации **/
  marketingAgreementAccepted?: TCreatePersonalMessageV2Request_MarketingAgreementAccepted;
  /** Идентификаторы пользователей, которым предназначается заявка (realty) **/
  specialistIds: number[];
  /** Тип сделки **/
  dealTypeEx: EDealTypeEx;
  /** Тип аренды **/
  rentType?: TCreatePersonalMessageV2Request_RentType;
  /** Тип объекта **/
  objectType: EObjectType;
  /** Количество комнат **/
  roomCount?: TCreatePersonalMessageV2Request_RoomCount;
  geo: IGeoExV4;
  /** Цена **/
  price?: TCreatePersonalMessageV2Request_Price;
  /** Площадь **/
  area?: TCreatePersonalMessageV2Request_Area;
  /** ФИО **/
  fullName: string;
  /** Телефон **/
  phone: string;
  /** E-mail **/
  email?: TCreatePersonalMessageV2Request_Email;
  /** Готовность снизить цену, в случае необходимости **/
  isReadyToLower?: TCreatePersonalMessageV2Request_IsReadyToLower;
  /** Объект в залоге у банка **/
  isBankDeposit?: TCreatePersonalMessageV2Request_IsBankDeposit;
  /** Объявление уже размещено? **/
  isHasOffer?: TCreatePersonalMessageV2Request_IsHasOffer;
  /** Уже накоплен первоначальный взнос? **/
  isMortgageInitialPayment?: TCreatePersonalMessageV2Request_IsMortgageInitialPayment;
  /** Наличие одобрения ипотеки от банка **/
  mortgageBankApprove?: TCreatePersonalMessageV2Request_MortgageBankApprove;
  /** Требуемый тип недвижимости **/
  offerType?: TCreatePersonalMessageV2Request_OfferType;
  /** Требуемая срочность завершения сделки **/
  dealPeriod?: TCreatePersonalMessageV2Request_DealPeriod;
  /** Тестовая заявка **/
  isTest?: TCreatePersonalMessageV2Request_IsTest;
  /** Источник заявки **/
  source: string;
  /** В кредит **/
  isCredit?: TCreatePersonalMessageV2Request_IsCredit;
  /** Как планируете покупать квартиру? **/
  purchaseMethod?: TCreatePersonalMessageV2Request_PurchaseMethod;
  /** Вы получили объект в наследство? **/
  isInheritance?: TCreatePersonalMessageV2Request_IsInheritance;
  /** В числе собственников есть несовершеннолетние? **/
  isMinorOwners?: TCreatePersonalMessageV2Request_IsMinorOwners;
  /** Первичная/вторичная недвижимость **/
  firstOrSecond?: TCreatePersonalMessageV2Request_FirstOrSecond;
  /** Уже выбрали проект дома под строительство? **/
  isProjectExists?: TCreatePersonalMessageV2Request_IsProjectExists;
  /** Рассматриваете вариант покупки участка и постройки {дома}? **/
  needLandForBuilding?: TCreatePersonalMessageV2Request_NeedLandForBuilding;
  /** Хотите подобрать проект дома и рассчитать его примерную стоимость? **/
  needProject?: TCreatePersonalMessageV2Request_NeedProject;
  /** Комментарий **/
  comment?: TCreatePersonalMessageV2Request_Comment;
}

export type TCreatePersonalMessageV2Request_MarketingAgreementAccepted = null | boolean;

export enum EDealTypeEx {
  /** Покупаю **/
  Buy = 'buy',
  /** Продаю **/
  Sale = 'sale',
  /** Сдаю **/
  Rent = 'rent',
  /** Арендую **/
  Tenant = 'tenant',
  /** Продаю, чтобы купить **/
  SellToBuy = 'sellToBuy',
}
export type TCreatePersonalMessageV2Request_RentType = null | ERentType;

export enum ERentType {
  /** Любой **/
  Any = 'any',
  /** От года **/
  Long = 'long',
  /** На несколько месяцев **/
  FewMonths = 'fewMonths',
  /** Посуточно **/
  Daily = 'daily',
}
export enum EObjectType {
  /** Квартира **/
  Flat = 'flat',
  /** Дом **/
  House = 'house',
  /** Часть дома **/
  HouseShare = 'houseShare',
  /** Участок **/
  Land = 'land',
  /** Таунхаус **/
  Townhouse = 'townhouse',
  /** Коттедж **/
  Cottage = 'cottage',
  /** Офис **/
  Office = 'office',
  /** Торговая площадь **/
  ShoppingArea = 'shoppingArea',
  /** Склад **/
  Warehouse = 'warehouse',
  /** Помещение свободного назначения **/
  FreeAppointmentObject = 'freeAppointmentObject',
  /** Общепит **/
  PublicCatering = 'publicCatering',
  /** Гараж **/
  Garage = 'garage',
  /** Производство **/
  Industry = 'industry',
  /** Автосервис **/
  CarService = 'carService',
  /** Готовый бизнес **/
  Business = 'business',
  /** Здание **/
  Building = 'building',
  /** Бытовые услуги **/
  DomesticServices = 'domesticServices',
  /** Коммерческая земля **/
  CommercialLand = 'commercialLand',
  /** Комната **/
  Room = 'room',
  /** Койко место **/
  Bed = 'bed',
  /** Доля в квартире **/
  FlatShare = 'flatShare',
  /** Продажа квартиры в новостройке **/
  NewBuildingFlat = 'newBuildingFlat',
}
export type TCreatePersonalMessageV2Request_RoomCount = null | ERoomCount[];

export enum ERoomCount {
  /** Однокомнатная квартира **/
  OneRoom = 'oneRoom',
  /** Двухкомнатная квартира **/
  TwoRoom = 'twoRoom',
  /** Трехкомнатная квартира **/
  ThreeRoom = 'threeRoom',
  /** Четырехкомнатная квартира **/
  FourRoom = 'fourRoom',
  /** Пятикомнатная квартира **/
  FiveRoom = 'fiveRoom',
  /** Многокомнатная квартира (6 и более комнат) **/
  Large = 'large',
  /** Квартира со свободной планировкой **/
  OpenPlan = 'openPlan',
  /** Студия **/
  Studio = 'studio',
}
export type TCreatePersonalMessageV2Request_Price = null | IPriceRangeEx;

export type TCreatePersonalMessageV2Request_Area = null | IDecimalRangeEx;

export type TCreatePersonalMessageV2Request_Email = null | string;

export type TCreatePersonalMessageV2Request_IsReadyToLower = null | boolean;

export type TCreatePersonalMessageV2Request_IsBankDeposit = null | boolean;

export type TCreatePersonalMessageV2Request_IsHasOffer = null | boolean;

export type TCreatePersonalMessageV2Request_IsMortgageInitialPayment = null | boolean;

export type TCreatePersonalMessageV2Request_MortgageBankApprove = null | EMortgageBankApprove;

export enum EMortgageBankApprove {
  /** Да **/
  Yes = 'yes',
  /** Нет **/
  No = 'no',
  /** В процессе **/
  InProcess = 'inProcess',
}
export type TCreatePersonalMessageV2Request_OfferType = null | EOfferType;

export enum EOfferType {
  /** Жилая **/
  Flat = 'flat',
  /** Загородная **/
  Suburban = 'suburban',
  /** Коммерческая **/
  Commercial = 'commercial',
}
export type TCreatePersonalMessageV2Request_DealPeriod = null | EDealPeriod;

export enum EDealPeriod {
  /** В течение 3 месяцев **/
  ThreeMonths = 'threeMonths',
  /** В течение 6 месяцев **/
  SixMonths = 'sixMonths',
  /** В течение 12 месяцев **/
  TwelveMonths = 'twelveMonths',
  /** В течение недели **/
  OneWeek = 'oneWeek',
  /** В течение 2 недель **/
  TwoWeek = 'twoWeek',
  /** В течение месяца **/
  OneMonth = 'oneMonth',
  /** В течение 7 дней **/
  SevenDays = 'sevenDays',
  /** В течение 2-3 недель **/
  TwoThreeWeeks = 'twoThreeWeeks',
  /** Больше месяца **/
  MoreMonth = 'moreMonth',
}
export type TCreatePersonalMessageV2Request_IsTest = null | boolean;

export type TCreatePersonalMessageV2Request_IsCredit = null | boolean;

export type TCreatePersonalMessageV2Request_PurchaseMethod = null | EPurchaseMethod;

export enum EPurchaseMethod {
  /** Наличные **/
  Cash = 'cash',
  /** Ипотека **/
  Mortgage = 'mortgage',
  /** Материнский капитал **/
  MaternalCapital = 'maternalCapital',
  /** Другое **/
  Other = 'other',
}
export type TCreatePersonalMessageV2Request_IsInheritance = null | boolean;

export type TCreatePersonalMessageV2Request_IsMinorOwners = null | boolean;

export type TCreatePersonalMessageV2Request_FirstOrSecond = null | EFirstOrSecond;

export enum EFirstOrSecond {
  /** Новостройка **/
  First = 'first',
  /** Вторичка **/
  Second = 'second',
  /** Неважно **/
  DoesNotMatter = 'doesNotMatter',
}
export type TCreatePersonalMessageV2Request_IsProjectExists = null | boolean;

export type TCreatePersonalMessageV2Request_NeedLandForBuilding = null | boolean;

export type TCreatePersonalMessageV2Request_NeedProject = null | boolean;

export type TCreatePersonalMessageV2Request_Comment = null | string;
